import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/Header';
import TTSTestSection from '@/components/TTSTestSection';
import { ROUTES } from '@/utils/constants';

const HomePage = () => {
  useEffect(() => {
    // Initialize WOW.js for animations
    if ((window as any).WOW) {
      new (window as any).WOW().init();
    }

    // Remove preloader
    const preloader = document.getElementById('preloader');
    if (preloader) {
      setTimeout(() => {
        preloader.style.opacity = '0';
        setTimeout(() => preloader.remove(), 300);
      }, 500);
    }

    // Initialize counter animation if available
    if ((window as any).jQuery && (window as any).jQuery.fn.counterUp) {
      (window as any).jQuery('.counter').counterUp({
        delay: 10,
        time: 1000
      });
    }
  }, []);

  return (
    <div className="main-page-wrapper p-30">
      {/* Preloader */}
      <div id="preloader">
        <div id="ctn-preloader" className="ctn-preloader">
          <div className="icon" style={{ 
            width: '120px', 
            height: '120px', 
            borderRadius: '50%', 
            backgroundColor: '#000000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            padding: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }}>
            <img 
              src="/images/logo/amebogpt-logo.png" 
              alt="ameboGPT" 
              className="m-auto d-block"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
            <span></span>
          </div>
          <div className="txt-loading" style={{ marginTop: '30px' }}>
            <span data-text-preloader="A" className="letters-loading">A</span>
            <span data-text-preloader="M" className="letters-loading">M</span>
            <span data-text-preloader="E" className="letters-loading">E</span>
            <span data-text-preloader="B" className="letters-loading">B</span>
            <span data-text-preloader="O" className="letters-loading">O</span>
          </div>
        </div>
      </div>

      <Header />

      {/* Hero Banner */}
      <div className="hero-banner-one bg-one border-30 z-1 pt-120 lg-pt-80 pb-100 lg-pb-70 mt-30 lg-mt-20 position-relative overflow-hidden">
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-7">
              <p className="fs-24 fw-500 text-dark mb-10 wow fadeInUp">Authentic Nigerian Voices!</p>
              <h1 className="hero-heading wow fadeInUp">
                Nigerian Text-to-Speech{' '}
                <span className="d-inline-block position-relative">
                  API
                  <img src="/images/shape/shape_01.svg" alt="" className="d-inline-block" />
                </span>
              </h1>
              <div className="row">
                <div className="col-xxl-10 col-lg-12">
                  <p className="fs-24 text-dark pt-25 pb-30 lg-pb-20 xs-pb-10 wow fadeInUp" data-wow-delay="0.1s">
                    Professional Nigerian-accented TTS API with support for English, Hausa, Igbo, Yoruba, and major Plateau languages.
                  </p>
                </div>
              </div>
              <ul className="style-none d-flex align-items-center flex-wrap">
                <li className="mt-10">
                  <Link to={ROUTES.SIGNUP} className="btn-one me-4">
                    Get Started Free
                  </Link>
                </li>
                <li className="mt-10">
                  <Link to={ROUTES.DOCS} className="btn-two xl">
                    View Documentation
                  </Link>
                </li>
              </ul>
              <p className="fs-22 pt-100 md-pt-50 md-pb-20">
                <span className="fw-500 text-dark text-decoration-underline">Join 1,000+</span> developers building with ameboGPT
              </p>
            </div>
            <div className="col-lg-6 col-md-5">
              <div className="hero-image-wrapper position-relative text-center wow fadeInRight" data-wow-delay="0.2s">
                <div className="img-holder position-relative z-1">
                  <img
                    src="/images/assets/gemini-hero.png"
                    alt="Nigerian Text-to-Speech API"
                    className="w-100"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      objectFit: 'contain',
                      borderRadius: '20px',
                      boxShadow: '0 20px 60px rgba(0,0,0,0.1)'
                    }}
                  />
                  {/* Decorative elements */}
                  <img
                    src="https://undraw.co/illustrations/voice-assistant.svg"
                    alt=""
                    className="position-absolute"
                    style={{
                      width: '120px',
                      height: '120px',
                      bottom: '-20px',
                      right: '-20px',
                      opacity: 0.3,
                      zIndex: -1
                    }}
                    onError={(e) => {
                      (e.target as HTMLImageElement).style.display = 'none';
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TTS Test Section */}
      <TTSTestSection />

      {/* Block Feature One */}
      <div className="block-feature-one border-30 bg-three mt-30 lg-mt-20 pt-150 lg-pt-80 pb-200 lg-pb-140">
        <div className="container">
          <div className="row align-items-start">
            <div className="col-xxl-7 col-lg-6 order-lg-last">
              <div className="ps-lg-5 ms-xxl-4 md-mb-60">
                <div className="title-one">
                  <h2>Authentic Nigerian Voices for Your Applications</h2>
                </div>
                <p className="fs-28 text-dark fw-500 mt-40 md-mt-20">
                  ameboGPT offers 22 unique Nigerian voices across 4 languages, perfect for building authentic voice experiences.
                </p>
                <div className="counter-wrapper mt-25 mb-70 lg-mb-50">
                  <div className="row gx-4">
                    <div className="col-6 col-md-3">
                      <div className="counter-block-one mt-20 text-center">
                        <div className="main-count fw-500 color-dark" style={{ fontSize: '48px', lineHeight: '1.2' }}>
                          22
                        </div>
                        <span className="fs-18 d-block mt-2">Unique Voices</span>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div className="counter-block-one mt-20 text-center">
                        <div className="main-count fw-500 color-dark" style={{ fontSize: '48px', lineHeight: '1.2' }}>
                          4
                        </div>
                        <span className="fs-18 d-block mt-2">Languages</span>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div className="counter-block-one mt-20 text-center">
                        <div className="main-count fw-500 color-dark" style={{ fontSize: '48px', lineHeight: '1.2' }}>
                          12
                        </div>
                        <span className="fs-18 d-block mt-2">English Voices</span>
                        <div className="mt-2">
                          <span className="fs-16 text-dark d-block">Hausa: 4 voices</span>
                          <span className="fs-16 text-dark d-block">Yoruba: 3 voices</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-md-3">
                      <div className="counter-block-one mt-20 text-center">
                        <div className="main-count fw-500 color-dark" style={{ fontSize: '48px', lineHeight: '1.2' }}>
                          10
                        </div>
                        <span className="fs-18 d-block mt-2">Native Voices</span>
                        <div className="mt-2">
                          <span className="fs-16 text-dark d-block">Igbo: 3 voices</span>
                          <span className="fs-16 text-dark d-block">6 Male / 6 Female</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Link to={ROUTES.SIGNUP} className="btn-two xl">
                  Start Building Now!
                </Link>
              </div>
            </div>
            <div className="col-xxl-5 col-lg-6 col-md-7 m-auto text-center order-lg-first d-flex align-items-start">
              <div className="img-holder z-1 w-100 position-relative" style={{ height: '100%', minHeight: '500px' }}>
                <img
                  src="/images/assets/features-section-hero.jpeg"
                  alt="Authentic Nigerian Voices"
                  className="w-100 h-100"
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '20px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                    objectFit: 'cover',
                    objectPosition: 'top center'
                  }}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://undraw.co/illustrations/mobile-apps.svg';
                  }}
                />
                {/* Decorative unDraw illustration overlay */}
                <img
                  src="https://undraw.co/illustrations/mobile-apps.svg"
                  alt=""
                  className="position-absolute d-none d-lg-block"
                  style={{
                    width: '100px',
                    height: '100px',
                    bottom: '-20px',
                    right: '-20px',
                    opacity: 0.2,
                    zIndex: -1
                  }}
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Block Feature Two - Features Grid */}
      <div className="block-feature-two mb-30 lg-mb-20 mt-80 lg-mt-60">
        <div className="container">
          <div className="title-one text-center mb-60">
            <h2>Why Choose ameboGPT?</h2>
            <p className="fs-20 text-dark mt-20">Everything you need to build voice-enabled applications</p>
          </div>
          <div className="row gx-xl-4">
            {[
              {
                icon: 'bi-mic',
                iconType: 'bootstrap',
                title: 'Multiple Voices',
                description: '12 English voices, 4 Hausa, 3 Igbo, 3 Yoruba voices for diverse applications',
                illustration: 'https://undraw.co/illustrations/team-work.svg',
              },
              {
                icon: '/images/icon/icon_02.svg',
                iconType: 'image',
                title: 'Fast API',
                description: 'Low latency, high performance TTS generation with 99.9% uptime',
                illustration: 'https://undraw.co/illustrations/speed.svg',
              },
              {
                icon: 'bi-code-slash',
                iconType: 'bootstrap',
                title: 'Developer Friendly',
                description: 'Simple REST API with comprehensive documentation and code examples',
                illustration: 'https://undraw.co/illustrations/code-review.svg',
              },
            ].map((feature, index) => (
              <div key={index} className="col-lg-4 d-flex wow fadeInUp mt-30 lg-mt-20" data-wow-delay={`${index * 0.1}s`}>
                <div className="card-style-one text-center border-30 bg-white w-100 h-100">
                  <div className="icon rounded-circle d-flex align-items-center justify-content-center m-auto mb-3" style={{ width: '80px', height: '80px', backgroundColor: '#f5f5f5', border: '2px solid #e0e0e0' }}>
                    {feature.iconType === 'bootstrap' ? (
                      <i className={`bi ${feature.icon}`} style={{ fontSize: '40px', color: '#000000' }}></i>
                    ) : (
                      <img src={feature.icon} alt={feature.title} style={{ width: '50px', height: '50px', filter: 'brightness(0)' }} />
                    )}
                  </div>
                  <h4 className="title mb-3">{feature.title}</h4>
                  <p className="mb-4">{feature.description}</p>
                  <div className="mt-auto">
                    <img
                      src={feature.illustration}
                      alt={feature.title}
                      className="w-100"
                      style={{ maxHeight: '200px', objectFit: 'contain' }}
                      onError={(e) => {
                        (e.target as HTMLImageElement).style.display = 'none';
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Use Cases Section */}
      <div className="use-cases-section border-30 bg-white mt-30 lg-mt-20 pt-120 lg-pt-80 pb-120 lg-pb-80">
        <div className="container">
          <div className="title-one text-center mb-80">
            <h2>Perfect For</h2>
            <p className="fs-20 text-dark mt-20">Use cases across industries</p>
          </div>
          {[
            {
              title: 'E-Learning Platforms',
              description: 'Create engaging educational content with authentic Nigerian voices. Perfect for online courses, tutorials, and interactive learning experiences that resonate with Nigerian students.',
              image: 'https://i.pinimg.com/1200x/60/79/d6/6079d6434b921f9d8d3c646c31d1c1f3.jpg',
              imageFirst: false,
            },
            {
              title: 'Customer Support',
              description: 'Enhance customer experience with natural voice interactions. Provide personalized support in Nigerian-accented English and native languages for better customer engagement.',
              image: 'https://i.pinimg.com/736x/05/72/ba/0572ba80787a7ec1c3afd11df80096cb.jpg',
              imageFirst: true,
            },
            {
              title: 'Content Creation',
              description: 'Generate voiceovers for videos, podcasts, and multimedia content. Bring your creative projects to life with diverse Nigerian voices that connect with your audience.',
              image: 'https://i.pinimg.com/736x/58/2e/3b/582e3b5a39d8e1760010fff66e33901e.jpg',
              imageFirst: false,
            },
            {
              title: 'Accessibility',
              description: 'Make your applications accessible with text-to-speech features. Help users with visual impairments or reading difficulties access your content in authentic Nigerian voices.',
              image: 'https://i.pinimg.com/1200x/bd/f3/e8/bdf3e8621178bc9207fec2d512de166a.jpg',
              imageFirst: true,
            },
          ].map((useCase, index) => (
            <div key={index} className={`row align-items-center mb-80 lg-mb-60 ${index > 0 ? 'mt-80 lg-mt-60' : ''}`}>
              {useCase.imageFirst ? (
                <>
                  <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="img-holder position-relative">
                      <img
                        src={useCase.image}
                        alt={useCase.title}
                        className="w-100"
                        style={{
                          height: '400px',
                          borderRadius: '20px',
                          boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = 'https://undraw.co/illustrations/online-learning.svg';
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="ps-lg-5">
                      <h3 className="title-one mb-4" style={{ fontSize: '42px', fontWeight: '700', fontFamily: '"Montserrat", sans-serif' }}>{useCase.title}</h3>
                      <p className="text-dark" style={{ fontSize: '20px', lineHeight: '1.8', fontWeight: '400' }}>{useCase.description}</p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="col-lg-6 mb-4 mb-lg-0 order-lg-first">
                    <div className="pe-lg-5">
                      <h3 className="title-one mb-4" style={{ fontSize: '42px', fontWeight: '700', fontFamily: '"Montserrat", sans-serif' }}>{useCase.title}</h3>
                      <p className="text-dark" style={{ fontSize: '20px', lineHeight: '1.8', fontWeight: '400' }}>{useCase.description}</p>
                    </div>
                  </div>
                  <div className="col-lg-6 order-lg-last">
                    <div className="img-holder position-relative">
                      <img
                        src={useCase.image}
                        alt={useCase.title}
                        className="w-100"
                        style={{
                          height: '400px',
                          borderRadius: '20px',
                          boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                          objectFit: 'cover',
                          objectPosition: 'center'
                        }}
                        onError={(e) => {
                          (e.target as HTMLImageElement).src = 'https://undraw.co/illustrations/online-learning.svg';
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Integration Section */}
      <div className="integration-section border-30 bg-three mt-30 lg-mt-20 pt-120 lg-pt-80 pb-120 lg-pb-80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="img-holder text-center">
                <img
                  src="/images/assets/integrate.png"
                  alt="Easy Integration"
                  className="w-100"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: '20px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://undraw.co/illustrations/api.svg';
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="title-one">
                <h2>Easy Integration</h2>
                <p className="fs-20 text-dark mt-20">
                  Get started in minutes with our simple REST API. Comprehensive documentation, code examples, and SDKs available.
                </p>
              </div>
              <ul className="style-none mt-40">
                <li className="d-flex align-items-start mb-20">
                  <div className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', backgroundColor: '#f0f0f0', flexShrink: 0 }}>
                    <i className="bi bi-check-circle-fill text-primary" style={{ fontSize: '24px' }}></i>
                  </div>
                  <div>
                    <h5 className="fw-500 mb-1">RESTful API</h5>
                    <p className="mb-0">Standard HTTP requests, JSON responses</p>
                  </div>
                </li>
                <li className="d-flex align-items-start mb-20">
                  <div className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', backgroundColor: '#f0f0f0', flexShrink: 0 }}>
                    <i className="bi bi-check-circle-fill text-primary" style={{ fontSize: '24px' }}></i>
                  </div>
                  <div>
                    <h5 className="fw-500 mb-1">Comprehensive Docs</h5>
                    <p className="mb-0">Detailed guides and code examples</p>
                  </div>
                </li>
                <li className="d-flex align-items-start">
                  <div className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', backgroundColor: '#f0f0f0', flexShrink: 0 }}>
                    <i className="bi bi-check-circle-fill text-primary" style={{ fontSize: '24px' }}></i>
                  </div>
                  <div>
                    <h5 className="fw-500 mb-1">Developer Support</h5>
                    <p className="mb-0">Dedicated support team ready to help</p>
                  </div>
                </li>
              </ul>
              <Link to={ROUTES.DOCS} className="btn-one mt-30">
                View Documentation
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Voice Donation CTA Section */}
      <div className="voice-donation-section border-30 bg-white mt-30 lg-mt-20 pt-120 lg-pt-80 pb-120 lg-pb-80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="title-one">
                <h2 style={{ fontSize: '48px', fontWeight: '700', fontFamily: '"Montserrat", sans-serif', marginBottom: '20px' }}>
                  Donate Your Voice
                </h2>
                <p className="fs-22 text-dark mt-20" style={{ lineHeight: '1.8', fontWeight: '400' }}>
                  Help us digitally preserve Nigerian languages! Donate your voice in your native language and earn exclusive benefits.
                </p>
                <div className="benefits-list mt-40">
                  <div className="d-flex align-items-start mb-3">
                    <div className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', backgroundColor: '#000000', flexShrink: 0 }}>
                      <i className="bi bi-award-fill text-white" style={{ fontSize: '24px' }}></i>
                    </div>
                    <div>
                      <h5 className="fw-600 mb-1" style={{ fontSize: '18px' }}>Lifetime Badge</h5>
                      <p className="mb-0 text-dark">Earn a special lifetime contributor badge for preserving your language</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-start mb-3">
                    <div className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', backgroundColor: '#000000', flexShrink: 0 }}>
                      <i className="bi bi-gift-fill text-white" style={{ fontSize: '24px' }}></i>
                    </div>
                    <div>
                      <h5 className="fw-600 mb-1" style={{ fontSize: '18px' }}>Special Monthly Credits</h5>
                      <p className="mb-0 text-dark">Receive exclusive monthly API credits for your contribution</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-start">
                    <div className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px', backgroundColor: '#000000', flexShrink: 0 }}>
                      <i className="bi bi-heart-fill text-white" style={{ fontSize: '24px' }}></i>
                    </div>
                    <div>
                      <h5 className="fw-600 mb-1" style={{ fontSize: '18px' }}>Language Preservation</h5>
                      <p className="mb-0 text-dark">Contribute to the digital preservation of Nigerian languages for future generations</p>
                    </div>
                  </div>
                </div>
                <Link to="/donate-voice" className="btn-one mt-40" style={{ fontSize: '18px', padding: '14px 32px' }}>
                  Donate Your Voice Now
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="img-holder text-center">
                <img
                  src="/images/assets/voices.jpeg"
                  alt="Donate Your Voice"
                  className="w-100"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    borderRadius: '20px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                    objectFit: 'cover'
                  }}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://undraw.co/illustrations/voice-assistant.svg';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section border-30 bg-one mt-30 lg-mt-20 pt-100 lg-pt-60 pb-100 lg-pb-60">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="title-one">
                <h2 className="text-dark" style={{ fontWeight: '700' }}>Ready to Get Started?</h2>
                <p className="fs-20 text-dark mt-20" style={{ fontWeight: '400' }}>
                  Join thousands of developers using ameboGPT to build amazing voice experiences.
                </p>
              </div>
            </div>
            <div className="col-lg-4 text-lg-end mt-4 mt-lg-0">
              <Link to={ROUTES.SIGNUP} className="btn-one me-3">
                Start Free Trial
              </Link>
              <Link to={ROUTES.PRICING} className="btn-two">
                View Pricing
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer-one border-top-light pt-80 lg-pt-50 pb-30">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6 mb-40 lg-mb-30">
              <div className="footer-intro">
                <div className="logo mb-20">
                  <Link to={ROUTES.HOME} className="d-flex align-items-center text-decoration-none">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: '60px',
                        height: '60px',
                        backgroundColor: '#000000',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        flexShrink: 0,
                      }}
                    >
                      <img src="/images/logo/amebogpt-logo.png" alt="ameboGPT" style={{ maxHeight: '50px', width: 'auto', padding: '5px' }} />
                    </div>
                    <span 
                      className="fw-bold text-dark"
                      style={{
                        fontSize: '28px',
                        fontFamily: '"Montserrat", sans-serif',
                        letterSpacing: '-0.5px',
                        lineHeight: '1.2em'
                      }}
                    >
                      ameboGPT
                    </span>
                  </Link>
                </div>
                <p className="text-dark" style={{ fontSize: '16px', lineHeight: '1.6', maxWidth: '300px' }}>
                  Authentic Nigerian Text-to-Speech API for developers. Digitally preserving Nigerian languages.
                </p>
              </div>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 mb-40 lg-mb-30">
              <h5 className="footer-title mb-20" style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Product</h5>
              <ul className="footer-link style-none">
                <li className="mb-2"><Link to={ROUTES.PRICING} className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Pricing</Link></li>
                <li className="mb-2"><Link to={ROUTES.DOCS} className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Documentation</Link></li>
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>API Reference</a></li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 mb-40 lg-mb-30">
              <h5 className="footer-title mb-20" style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Company</h5>
              <ul className="footer-link style-none">
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>About</a></li>
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Blog</a></li>
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Contact</a></li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 mb-40 lg-mb-30">
              <h5 className="footer-title mb-20" style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Legal</h5>
              <ul className="footer-link style-none">
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Privacy Policy</a></li>
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Terms of Service</a></li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-6 mb-40 lg-mb-30">
              <h5 className="footer-title mb-20" style={{ fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>Resources</h5>
              <ul className="footer-link style-none">
                <li className="mb-2"><Link to="/donate-voice" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Donate Voice</Link></li>
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Support</a></li>
                <li className="mb-2"><a href="#" className="text-dark" style={{ fontSize: '15px', textDecoration: 'none' }}>Status</a></li>
              </ul>
            </div>
          </div>
          <div className="bottom-footer pt-30 border-top-light">
            <div className="row align-items-center">
              <div className="col-md-6 mb-3 mb-md-0">
                <p className="copyright text-center text-md-start mb-0" style={{ fontSize: '14px', color: '#666' }}>
                  Copyright © {new Date().getFullYear()} <a href="#" className="text-dark fw-500" style={{ textDecoration: 'none' }}>ameboGPT</a> All rights reserved.
                </p>
              </div>
              <div className="col-md-6">
                <ul className="style-none d-flex justify-content-center justify-content-md-end footer-social mb-0">
                  <li className="me-3"><a href="#" className="text-dark" style={{ fontSize: '18px', textDecoration: 'none' }}><i className="fab fa-twitter"></i></a></li>
                  <li className="me-3"><a href="#" className="text-dark" style={{ fontSize: '18px', textDecoration: 'none' }}><i className="fab fa-facebook-f"></i></a></li>
                  <li className="me-3"><a href="#" className="text-dark" style={{ fontSize: '18px', textDecoration: 'none' }}><i className="fab fa-instagram"></i></a></li>
                  <li><a href="#" className="text-dark" style={{ fontSize: '18px', textDecoration: 'none' }}><i className="fab fa-linkedin-in"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
